import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import imglogo from "../../assets/logoTransparent.png";
import { useDispatch, useSelector } from "react-redux";
import { TbLogout } from "react-icons/tb";
import { logout } from "../../store/reducer/authUser";
import NotificationMenu from "./NotificationMenu";
function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.authUser?.data);
  const { data } = useSelector((state) => state?.authUser?.data);
  const ramaUser = "687f6c6fc14ca8470b40b732";
  const shardaUser = "687f6cddc14ca8470b40b734";
  //console.log("data", data);
  const HandleLogout = () => {
    dispatch(logout());
    navigate("/sign-in");
  };
  return (
    <>
      <div className="taskHeader py-3">
        <div className="container-fluid">
          <div className="row justify-content-between">
            {/* <div className="col-xl-2">
              <img
                src={imglogo}
                className="img-fluid"
                alt="GreyMatterz"
                style={{ marginLeft: "55px" }}
              />
            </div> */}
            <div className="col-xl-12">
              <ul className="menuCst d-flex align-items-center justify-content-end gap-4 m-0 p-0">
                <li className="userClass">
                  <NotificationMenu />
                </li>
                {userData ? (
                  <li className="userClass">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="userBtn btn"
                        id="dropdown-basic"
                      >
                        {/* <img className="me-2" src="/Image/user.png" /> */}
                        {data?.user_id === ramaUser
                          ? "Rama university"
                          : data?.user_id === shardaUser
                          ? "Sharda university"
                          : data?.email}
                        {/* {userData?.email_id} */}
                        {/* <FaAngleDown /> */}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#" onClick={HandleLogout}>
                          <span>
                            <TbLogout />
                          </span>{" "}
                          Log Out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                ) : (
                  <li className="loginBtn">
                    <Link>Login</Link>
                  </li>
                )}
                {/* <li>
                  <Link to="/term-and-condition">Term's And Condition</Link>
                </li>
                <li>
                  <Link to="/purchase-policy">Purchase Policy</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">privacy-policy</Link>
                </li>
                <li>
                  <button className="greenBtn" onClick={handleSignup}>
                    Signup for free
                  </button>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
